import React from "react";

export function useControlled<T>({
  controlled,
  default: defaultValue,
  name,
  state,
}: {
  controlled: T | undefined;
  default: T | undefined;
  name: string;
  state: string;
}) {
  const { current: isControlled } = React.useRef(controlled !== undefined);
  const [valueState, setValue] = React.useState(defaultValue);
  const value = isControlled ? controlled : valueState;

  if (process.env.NODE_ENV !== "production") {
    // biome-ignore lint/correctness/useHookAtTopLevel: based on NODE_ENV
    React.useEffect(() => {
      if (isControlled !== (controlled !== undefined)) {
        console.error(
          `${name} component is changing from ${
            isControlled ? "controlled" : "uncontrolled"
          } to ${isControlled ? "uncontrolled" : "controlled"} ${state}`,
        );
      }
    }, [state, name, controlled, isControlled]);
  }

  const setValueIfUncontrolled = React.useCallback(
    (newValue: T) => {
      if (!isControlled) {
        setValue(newValue);
      }
    },
    [isControlled],
  );

  return [value, setValueIfUncontrolled] as const;
}
